import React from 'react';
import { fromJS } from 'immutable';
import { BaseComponent } from 'kryfe-lib';

import { Icon, Input, AutoComplete } from 'antd';
import hot from 'assets/images/hot.png';

const Option = AutoComplete.Option;

class AutoCompleteComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // 获取城市列表
    this.props.getCity();
  }

  // 过滤城市
  filterOptionCB = (inputValue, option) => {
    // 去除用户空格
    let valueFomat = inputValue.replace(/\s/g, '');
    if (valueFomat) {
      // 首先判断该整条数据为字母还是汉字
      if (/^[\u4e00-\u9fa5]+$/.test(valueFomat)) {
        return option.props.value.indexOf(inputValue) != -1 ? true : false;
      } else if (/^[a-z]+$/.test(valueFomat)) {
        return option.props.shortName.indexOf(inputValue) != -1 ? true : false;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  render() {
    const cityOption = this.props.citySource.map((item, index) => {
      return (
        <Option
          className="cityOption"
          key={item.get('cityCode')}
          value={item.get('cityName')}
          shortName={item.get('shortName')}
        >
          {item.get('cityName')}
          {index < 5 ? <img className="hotIcon" src={hot} /> : null}
        </Option>
      );
    });

    return (
      <AutoComplete
        dataSource={cityOption}
        placeholder="请输入您的所在城市"
        size="large"
        filterOption={this.filterOptionCB}
        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
        onChange={this.props.onChange}
        value={this.props.value}
        optionLabelProp="value"
        allowClear
      >
        <Input maxLength="16" />
      </AutoComplete>
    );
  }
}

export default AutoCompleteComp;



// WEBPACK FOOTER //
// ./src/pages/newHome/components/ApplyForm/ApplyFormCompChildDir/AutoCompleteComp.jsx